import * as React from 'react';
import classNames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Spinner from 'components/spinner/Spinner';

import './like-content-action-button.scss';

type Props = {
  isLoading?: boolean,
  isFavourite?: boolean,
  onClick?: (event: React.SyntheticEvent<HTMLElement>) => void
};

const LikeContentActionButton = (
  {
    isLoading,
    isFavourite = true,
    onClick
  }: Props
): JSX.Element => {
  const containerClasses = classNames('like-content-action-button__container', {
    'like-content-action-button__container--favourite': isFavourite
  });

  return (
    <div
      className={containerClasses}
      onClick={(event: React.SyntheticEvent<HTMLElement>) => {
        if (!isLoading && onClick) {
          onClick(event);
        }
      }}
    >
      {
        isLoading ? (
          <Spinner
            position="inline"
            size="tiny"
            color="light"
          />
        ) : (
          <SVGDynamicIcon
            name="heart-custom-bg"
            width={16}
            height={16}
            customColor={isFavourite ? 'red' : 'white'}
          />
        )
      }
    </div>
  );
};

export default LikeContentActionButton;
